/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Notices_FileContentDto } from '../models/Wealthlane_AwardService_Dtos_Notices_FileContentDto';
import type { Wealthlane_AwardService_Dtos_Notices_NoticeRequestDto } from '../models/Wealthlane_AwardService_Dtos_Notices_NoticeRequestDto';
import type { Wealthlane_AwardService_Dtos_Notices_NoticeResponseDto } from '../models/Wealthlane_AwardService_Dtos_Notices_NoticeResponseDto';
import type { Wealthlane_AwardService_Interfaces_Notices_NoticeGeneratorAwardType } from '../models/Wealthlane_AwardService_Interfaces_Notices_NoticeGeneratorAwardType';
import type { Wealthlane_AwardService_Notices_NoticeType } from '../models/Wealthlane_AwardService_Notices_NoticeType';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NoticeService {
  /**
   * @param type
   * @param awardId
   * @param awardType
   * @returns string OK
   * @throws ApiError
   */
  public static getApiAwardApiNoticesGrantAcceptance(
    type?: Wealthlane_AwardService_Notices_NoticeType,
    awardId?: string,
    awardType?: Wealthlane_AwardService_Interfaces_Notices_NoticeGeneratorAwardType
  ): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/award/api/notices/grant-acceptance',
      query: {
        Type: type,
        AwardId: awardId,
        AwardType: awardType,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @returns Wealthlane_AwardService_Dtos_Notices_NoticeResponseDto OK
   * @throws ApiError
   */
  public static getApiAwardApiNotices(): CancelablePromise<
    Array<Wealthlane_AwardService_Dtos_Notices_NoticeResponseDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/award/api/notices',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param requestBody
   * @returns Wealthlane_AwardService_Dtos_Notices_NoticeResponseDto OK
   * @throws ApiError
   */
  public static postApiAwardApiNotices(
    requestBody?: Wealthlane_AwardService_Dtos_Notices_NoticeRequestDto
  ): CancelablePromise<Wealthlane_AwardService_Dtos_Notices_NoticeResponseDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/award/api/notices',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param requestBody
   * @returns Wealthlane_AwardService_Dtos_Notices_NoticeResponseDto OK
   * @throws ApiError
   */
  public static postApiAwardApiNoticesManage(
    requestBody?: Wealthlane_AwardService_Dtos_Notices_NoticeRequestDto
  ): CancelablePromise<Wealthlane_AwardService_Dtos_Notices_NoticeResponseDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/award/api/notices/manage',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param id
   * @param requestBody
   * @returns Wealthlane_AwardService_Dtos_Notices_NoticeResponseDto OK
   * @throws ApiError
   */
  public static putApiAwardApiNotices(
    id: string,
    requestBody?: Wealthlane_AwardService_Dtos_Notices_NoticeRequestDto
  ): CancelablePromise<Wealthlane_AwardService_Dtos_Notices_NoticeResponseDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/award/api/notices/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param id
   * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
   * @throws ApiError
   */
  public static deleteApiAwardApiNotices(
    id: string
  ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/award/api/notices/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param id
   * @returns Wealthlane_AwardService_Dtos_Notices_NoticeResponseDto OK
   * @throws ApiError
   */
  public static getApiAwardApiNotices1(
    id: string
  ): CancelablePromise<Wealthlane_AwardService_Dtos_Notices_NoticeResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/award/api/notices/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param formData
   * @returns string OK
   * @throws ApiError
   */
  public static postApiAwardApiNoticesSnapshot(formData?: {
    File?: Blob;
    AwardId?: string;
  }): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/award/api/notices/snapshot',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param formData
   * @returns string OK
   * @throws ApiError
   */
  public static postApiAwardApiNoticesSnapshotv2(formData?: {
    File?: Blob;
    AwardId?: string;
  }): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/award/api/notices/snapshotv2',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param awardId
   * @returns Wealthlane_AwardService_Dtos_Notices_FileContentDto OK
   * @throws ApiError
   */
  public static getApiAwardApiNoticesGrantAcceptancePdf(
    awardId: string
  ): CancelablePromise<Wealthlane_AwardService_Dtos_Notices_FileContentDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/award/api/notices/grant-acceptance/pdf/{awardId}',
      path: {
        awardId: awardId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }
}
